<div id="loader" *ngIf="isLoader">
    <div id="shadow"></div>
    <div id="box"></div>
    <h4><b>Loading..</b></h4>
</div>
<div *ngIf="body">
    <mat-card style="background: transparent;">
        <mat-card class="card_style">

            <div>

                <div style="text-align: center; padding-top: 50px;">

                    <h1 style="margin-top: -18px;"><b>Marketing Campaign</b></h1>

                </div>
            </div>





            <div style="text-align:left;">
                <div>
                    <div style="margin-bottom: 2%;">
                        <img class="excel-button" src="https://cdn-icons-png.flaticon.com/128/732/732220.png" width="35"
                            height="35" (click)="excelExport()">
                    </div>
                    <div class="d-flex mb-3">
                    <div class="filter-dropdown">
                        <label class="label-filter" style="font-weight: 400; font-size: 14px;" for="">Industry Type:</label>
                        <ng-select placeholder="Select Industry Type" class="me-3" [items]="industry_type" (change)="industrySelected()" [(ngModel)]="search_filter.industry_type" bindLabel="name" bindValue="name"></ng-select>
                    </div>
                    <div class="filter-dropdown">
                        <label class="label-filter" style="font-weight: 400; font-size: 14px;" for="">Marketing Team:</label>
                        <ng-select placeholder="Select Marketing Team" class="me-3" [items]="marketingteamdrop" (change)="marketingTeamSelected()" [(ngModel)]="search_filter.marketing_team_id" bindLabel="name" bindValue="_id"></ng-select>
                    </div>
                    <div class="filter-dropdown">
                        <label class="label-filter" style="font-weight: 400;font-size: 14px;" for="">Country:</label>
                        <ng-select placeholder="Select Country" class="me-3" [items]="country_drop" (change)="countrySelected()" [(ngModel)]="search_filter.marketing_country_id" bindLabel="name" bindValue="_id"></ng-select>
                    </div>
                    <div class="filter-dropdown">
                        <label class="label-filter" style="font-weight: 400;font-size: 14px;" for="">State:</label>
                        <ng-select placeholder="Select State" class="me-3" [items]="statedrop" (change)="stateSelected()" [(ngModel)]="search_filter.marketing_state_id" bindLabel="name" bindValue="_id"></ng-select>
                    </div>
                    <div class="filter-dropdown">
                        <label class="label-filter" style="font-weight: 400;font-size: 14px;" for="">Area:</label>
                        <ng-select placeholder="Select Area" class="me-3" [items]="areadrop" (change)="areaSelected()" [(ngModel)]="search_filter.marketing_area_id" bindLabel="name" bindValue="_id"></ng-select>
                    </div>

                    <div class="filter-dropdown">
                        <label class="label-filter" style="font-weight: 400;font-size: 14px;" for="">Created By:</label>
                        <ng-select placeholder="Select Employee" class="me-3" [items]="employeedrop" (change)="createdBySelected()" [(ngModel)]="search_filter.created_by_id" bindLabel="employee_name" bindValue="employee_id"></ng-select>
                    </div>

                    <div class="filter-dropdown">
                        <label class="label-filter" style="font-weight: 400;font-size: 14px;" for="">Customer:</label>
                        <input type="text" [(ngModel)]="search_filter.customer_name" (ngModelChange)="customerSelected()" class="form-control me-3">
                    </div>
                    <!-- <div class="filter-dropdown">
                        <label class="label-filter ms-3" style="font-weight: 400;font-size: 14px;" for="">Type:</label>
                        <input type="text" [(ngModel)]="search_filter.customer_type" (ngModelChange)="customerSelected()" class="form-control ms-3">
                    </div> -->
                     </div>

                    <div class="table-responsive">
                      
                        <table class="table" id="MarketStudy">
                            <thead>
                                <tr>

                                    <th scope="col" style="width: 40%;">Sequence No</th>
                                    <th scope="col" style="width: 40%;">Industry Type</th>
                                    <th scope="col" style="width: 40%;">Country</th>
                                    <th scope="col" style="width: 40%;" >State</th>
                                    <th scope="col" style="width: 40%;" >Area</th>
                                    <th scope="col" style="width: 40%;">Latitude</th>
                                    <th scope="col" style="width: 40%;">Longitude</th>
                                    <th scope="col" style="width: 40%;">Marketing Team Name</th>
                                    <th scope="col" style="width: 40%;">Customer</th>
                                    <th scope="col" style="width: 40%;">Manager / Owner Whatsapp Number</th>
                                    <th scope="col" style="width: 40%;">Number of Painters</th>
                                    <th scope="col" style="width: 40%;">Painter Whatsapp Number</th>
                                    <th scope="col" style="width: 40%;">Whatsapp Number Verified or Not</th>
                                    <th scope="col" style="width: 40%;">Owners Nationality</th>
                                    <th scope="col" style="width: 40%;">Painter Name</th>
                                    <th scope="col" style="width: 40%;">Number of Panels Painted Per Day</th>
                                
                                    <th scope="col" style="width: 60%;">Current Supplier</th>
                                    <th scope="col" style="width: 60%;">Body filler Brand</th>

                                    <th scope="col" style="width: 60%;">Two_k Primer Brand</th>
                                    <th scope="col" style="width: 60%;">One_k Primer Brand</th>
                                    <th scope="col" style="width: 60%;">Paint Brand</th>
                                    <th scope="col" style="width: 60%;">Clear Coat Brand</th>
                                    <th scope="col" style="width: 60%;">Nc Thinner Brand</th>
                                    <th scope="col" style="width: 60%;">Two_k Thinner Brand</th>
                                    <th scope="col" style="width: 60%;">Abrasive Brand</th>
                                    <th scope="col" style="width: 60%;">NC Paint Brand</th>
                                    <th scope="col" style="width: 60%;">PU Paint Brand</th>
                                    <th scope="col" style="width: 60%;">Thinner Brand</th>
                                    <th scope="col" style="width: 60%;">Stain Brand</th>
                                    <th scope="col" style="width: 60%;">Class of Garage</th>
                                    <th scope="col" style="width: 60%;">Created By</th>

                                    <th scope="col" style="width: 60%;">Created At</th>
                                    <th scope="col" style="width: 60%;">Updated At</th>
                                    <th scope="col" style="width: 60%;">Image</th>
                                  



                                </tr>
                            </thead>
                            <tbody class="table-bordered">
                                <ng-container *ngFor="let employee of output">
                                    <tr>
                                        <td>{{employee?.sequence_no}}</td>
                                        <td>{{ employee?.industry_type}}</td>
                                        <td>{{ employee?.marketing_country?.name}}</td>
                                        <td >{{ employee?.marketing_state?.name}}</td>
                                        <td >{{ employee?.marketing_area?.name}}</td>
                                        <td>{{ employee?.latitude}}</td>
                                        <td>{{ employee?.longitude}}</td>
                                        <td>{{ employee?.marketing_team?.name }}</td>
                                        <td>{{ employee?.customer_name}}</td>
                                        <td>{{ employee?.owner_or_manager_whatsapp_no }}</td>
                                        <td>{{ employee?.no_of_painters }}</td>
                                        <td>{{ employee?.whatsapp_number}}</td>
                                        <td *ngIf="employee?.is_whatsapp_no_verified === true">Yes</td>
                                        <td *ngIf="!employee?.is_whatsapp_no_verified || employee?.is_whatsapp_no_verified === false">No</td>
                                        <td>{{ employee?.owners_nationality}}</td>
                                        <td>{{employee?.painter_name}}</td>
                                        <td>{{employee?.no_of_panels_painted_per_day}}</td>
                                        <td>
                                            <div *ngFor="let name of employee?.current_supplier">
                                                {{name}},
                                            </div>
                                        </td>
                                        <td>
                                            <div *ngFor="let filler of employee?.body_filler_brand">
                                                {{filler}},
                                            </div>
                                        </td>


                                        <td>{{employee?.two_k_primer_brand}}</td>
                                        <td>{{employee?.one_k_primer_brand}}</td>
                                        <td>{{employee?.paint_brand}}</td>
                                        <td>{{employee?.clear_coat_brand}}</td>
                                        <td>{{employee?.nc_thinner_brand}}</td>
                                        <td>{{employee?.two_k_thinner_brand}}</td>
                                        <td>{{employee?.abrasive_brand}}</td>
                                        <td>{{employee?.nc_paint_brand}}</td>
                                        <td>{{employee?.pu_paint_brand}}</td>
                                        <td>{{employee?.thinner_brand}}</td>
                                        <td>{{employee?.stain_brand}}</td>
                                       


                                        <td>{{employee?.class_of_garage}}</td>
                                        <td>{{employee?.created_by?.employee_name}}</td>
                                        <td>{{employee?.createdAt | date:'medium'}}</td>
                                        <td>{{employee?.updatedAt | date:'medium'}}</td>
                                        <!-- <td><img class="img-fluid image" src="{{employee?.image_url}}" alt="img"></td> -->
                                        <td hidden>{{employee?.image_url}}</td>
                                        <td>
                                              <img *ngIf="!employee?.image_url || employee?.image_url == 'null' || employee?.image_url == ''" class="img-fluid" src="assets/img/upload-image.jpg" alt="img">
                                            <a *ngIf="employee?.image_url" [href]="employee?.image_url" target="_blank">
                                                <img class="img-fluid image" [src]="employee?.image_url" alt="img">
                                              </a>
                                          </td>
                                          


                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>